module.exports = __webpack_public_path__ + "img/way_b.188e4af6.jpg";